import React from 'react';

import { SubRoutes } from '../../routes';

import OrderListPage from './_list';
import OrderCreatePage from './_create';
import OrderCreateBatchPage from './_createBatch';

const MainOrderPage = () => {
  return <SubRoutes name="order" />;
};

const Order = {
  MainOrderPage,
  OrderListPage,
  OrderCreatePage,
  OrderCreateBatchPage,
};

export default Order;
